import { render, staticRenderFns } from "./receivingInformation.vue?vue&type=template&id=24b93446"
import script from "./receivingInformation.vue?vue&type=script&lang=js"
export * from "./receivingInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b93446')) {
      api.createRecord('24b93446', component.options)
    } else {
      api.reload('24b93446', component.options)
    }
    module.hot.accept("./receivingInformation.vue?vue&type=template&id=24b93446", function () {
      api.rerender('24b93446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/receivingInformation.vue"
export default component.exports